export const MSG_ID_PREFIX = 'app.collapsible.picker';

export const LIST_TOP_PADDING = 12;
export const SELECTED_ITEM_PADDING = 16;
export const ITEM_PADDING = 24;
export const DEFAULT_SELECTED_ITEM_HEIGHT = 60;
export const DEFAULT_LIST_ITEM_HEIGHT = 30;
